import { defineStore } from 'pinia';
import to from 'await-to-js';
import { apis } from '/@/apis';
import { AvailableMagicBeanInfoRes, StorageInfoRes } from '@lingtu//apis/entities';

const { transactions } = apis;
const { batch } = apis;
interface ICommerceStoreState {
  lingdouInfo: AvailableMagicBeanInfoRes | null;
  storageInfo: StorageInfoRes;
  fetchingLingdouInfo: boolean;
  fetchingStorageInfo: boolean;
}

export const useCommerceStore = defineStore({
  id: 'commerce',
  state: (): ICommerceStoreState => ({
    lingdouInfo: null,
    storageInfo: {
      total: 0,
      use: 0,
      remain: 0,
    },
    fetchingLingdouInfo: false,
    fetchingStorageInfo: false,
  }),
  getters: {
    // 是否是会员
    isVip(): boolean {
      return !!this.lingdouInfo?.memberShip?.member;
    },

    // 剩余灵豆数量
    lingdouNum(): number {
      return this.lingdouInfo?.total || 0;
    },

    // 席位上限
    seatUpperLimit(): number {
      return this.lingdouInfo?.memberShip?.seat || 0;
    },
    // 是否拥有智绘画布权限
    hasCanvasPermission(): boolean {
      return !!this.lingdouInfo?.memberShip?.canvas;
    },

    // 是否只能下载水印图片
    onlyWatermarkImg(): boolean {
      return !!!this.lingdouInfo?.memberShip?.noWaterMarkDownload;
    },
  },
  actions: {
    // 获取灵豆信息，如果已经存在信息不会重新获取
    async getLingdouInfo() {
      if (this.lingdouInfo) {
        return this.lingdouInfo;
      }
      const lingdouInfo = await this.updateLingdouInfo();

      return lingdouInfo;
    },

    // 重新获取灵豆信息
    async updateLingdouInfo() {
      if (!this.fetchingLingdouInfo) {
        this.fetchingLingdouInfo = true;
        const [_, res] = await to(transactions.availableMagicBeanInfo());
        this.lingdouInfo = res || null;
        this.fetchingLingdouInfo = false;
        return this.lingdouInfo;
      } else {
        return await new Promise((resolve) => {
          this.$subscribe(() => {
            if (this.lingdouInfo) {
              resolve(this.lingdouInfo);
            }
          });
        });
      }
    },

    // 获取存储容量信息，如果已经存在信息不会重新获取
    async getStorageInfo() {
      if (this.storageInfo) {
        return this.storageInfo;
      }
      const storageInfo = await this.updateStorageInfo();

      return storageInfo;
    },

    // 重新获取存储容量信息
    async updateStorageInfo() {
      if (!this.fetchingStorageInfo) {
        this.fetchingStorageInfo = true;
        const [_storageErr, storageRes] = await to(transactions.getStorageInfo());
        const [_spaceSizeErr, spaceSizeRes] = await to(batch.getSpaceSize({}));
        if (_storageErr || _spaceSizeErr) {
          return;
        }
        const GB = 1024 ** 3;
        const used = Number(spaceSizeRes || 0) / GB;
        const total = Number(storageRes || 0);
        const remainNum = total - used;

        this.storageInfo = {
          total,
          use: +used.toFixed(2),
          remain: +(remainNum > 0 ? remainNum : 0).toFixed(2),
        };
        this.fetchingStorageInfo = false;
        return this.storageInfo;
      } else {
        return await new Promise((resolve) => {
          this.$subscribe(() => {
            if (this.storageInfo) {
              resolve(this.storageInfo);
            }
          });
        });
      }
    },
  },
});

export function useCommerceStoreWithOut() {
  return useCommerceStore();
}
